(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class ProductDescription extends HTMLElement {
    constructor() {
      super();
    }
    render(product, variant) {
      const description = variant?.description?.value ? variant.description.value : product?.descriptionHtml ?? null;
      const disclaimer = variant?.disclaimer?.value ? JSON.parse(variant.disclaimer.value) : null;
      const datasheets = variant?.data_sheets?.value ? JSON.parse(variant.data_sheets.value) : null;
      if(this.descriptionNode && description) {
        this.descriptionNode.innerHTML = `${description}`;
      }
      if (this.additionalVariantMetaNode) {   
        this.additionalVariantMetaNode.innerHTML = disclaimer?.text || (datasheets && datasheets.length > 0) ? `
          <div class="variant-metafields-data">
            <hr>
            ${disclaimer?.text ? disclaimer.text : ''}
            ${datasheets ? `
              ${datasheets.length > 0 ? `<p><b>${ window.Shopify?.theme?.translations?.products?.product?.datasheet ?? 'missing translation'}:</b></p>`: ''}
              ${datasheets.map(datasheet => `
                <a class="btn btn--datasheet" href="${datasheet.url}" target="_blank"> 
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 17.80078 21.80078"><path d="M14.90039,21.80078h-12A2.90451,2.90451,0,0,1,0,18.90039v-16A2.90451,2.90451,0,0,1,2.90039,0h12a2.90451,2.90451,0,0,1,2.90039,2.90039v16A2.90451,2.90451,0,0,1,14.90039,21.80078Zm-12-20A1.10071,1.10071,0,0,0,1.80078,2.90039v16A1.1007,1.1007,0,0,0,2.90039,20h12A1.1007,1.1007,0,0,0,16,18.90039v-16a1.1007,1.1007,0,0,0-1.09961-1.09961Z"></path><path d="M12.90039,6.67871h-8a.7002.7002,0,0,1,0-1.40039h8a.7002.7002,0,1,1,0,1.40039Z"></path><path d="M12.80762,10.42383H4.90039a.7002.7002,0,0,1,0-1.40039h7.90723a.7002.7002,0,0,1,0,1.40039Z"></path> <path d="M8.47168,14.169H4.90039a.7002.7002,0,0,1,0-1.4004H8.47168a.7002.7002,0,0,1,0,1.4004Z"></path></svg>
                  ${datasheet.title} 
                </a> 
              `).join('')}
            ` : ''}
          </div>
        ` : '';
      }
    }
    connectedCallback() {
      this.descriptionNode = this.querySelector('.product-description-data');
      this.additionalVariantMetaNode = this.querySelector('.pdp-variant-metafields');
      document.addEventListener('on:variant:change', (event) => {
        const { product, variant } = event.detail;
        this.render(product, variant);
      });
    }
  }
  if (!customElements.get('product-description')) {
    customElements.define('product-description', ProductDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vat-popup"] && !Shopify.designMode) return;
  try {
    
  class VatPopup extends HTMLElement {
    constructor() {
      super();
    }
    hideSection() {
      if (window.Shopify?.designMode) {
        this.section.classList.remove('active');
      } else {
        this.section.remove();
      }
    }
    showSection() {
      this.section.classList.add('active');
    }
    init() {
      this.section = this.closest('.shopify-section');
      this.sectionId = this.section.id.replace('shopify-section-', '');
      const with_vat_button = this.querySelector('.switcher-buttons .with_vat-button');
      const without_vat_button = this.querySelector('.switcher-buttons .without_vat-button');
      const save_check = this.querySelector('#no_show_again');
      with_vat_button.addEventListener('click', event => {
        localStorage.setItem('include_vat', 'true');
        window.toggleVat();
        if(save_check.checked == true) {
          localStorage.setItem('hide_vat_popup', 'true');
        }
        this.hideSection();
      });
      without_vat_button.addEventListener('click', event => {
        localStorage.setItem('include_vat', 'false')
        window.toggleVat();
        if(save_check.checked == true) {
          localStorage.setItem('hide_vat_popup', 'true')
        }
        this.hideSection();
      });
    }
    sectionSelectCallback(event) {
      if(event.detail.sectionId == this.sectionId){
        this.showSection();
      }
    }
    sectionDeselectCallback(event) {
      if(event.detail.sectionId == this.sectionId){
        this.hideSection();
      }
    }
    connectedCallback() {
      this.init();
      this.selectFunctionHandle = this.sectionSelectCallback.bind(this);
      this.deselectFunctionHandle = this.sectionDeselectCallback.bind(this)
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:section:select', this.selectFunctionHandle);
        document.addEventListener('shopify:section:deselect',this.deselectFunctionHandle);
      } else {
        if(localStorage.getItem('hide_vat_popup') === 'true'){
          this.hideSection();
        } else {
          setTimeout(() => {
            this.showSection();
          }, 3000);
        }
      }
    }
    disconnectedCallback() {
      document.removeEventListener('shopify:section:select', this.selectFunctionHandle);
      document.removeEventListener('shopify:section:deselect',this.deselectFunctionHandle);
    }
  }
  if(!customElements.get('vat-popup')) {
    customElements.define('vat-popup', VatPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
